<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <div :class="$style.content">
            <el-row>
                <el-col :span="12">
                    <div align="left" style="color: #FF9901">
                        <span>{{yearStr}}年</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div align="right">
                        <span style="color: #FF9901">{{actualamount}}</span>
                        <span style="font-size: 12px;color: #B2B4B9">元</span>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="1">
                    <div style="height: 150px;display: table-cell;vertical-align: middle;text-align: center;cursor:pointer">
                        <img :src="l_icon" width="20px" @click.stop="lastNextYearClick(-1)"/>
                    </div>
                </el-col>

                <el-col :span="22">
                    <div style="width:100%;height: 200px" ref="myEchart">
                    </div>
                    <div style="color:#9B9B9B;font-size:12px;width:100%;margin-top:-25px;text-align: center">
                        <span>柱形为当月实际销售金额   曲线为当月销售指标金额</span>
                        <hr style="margin-left:40px;margin-right:20px;margin-top:10px;margin-bottom:12px;background-color: #DEDEDE"/>
                    </div>

                </el-col>
                <el-col :span="1">
                    <div style="height: 150px;display: table-cell;vertical-align: middle;text-align: center;cursor:pointer">
                        <img :src="r_icon" width="20px" @click.stop="lastNextYearClick(1)"/>
                    </div>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="8">
                    <span style="color: white">.</span>
                </el-col>

                <el-col :span="8" align="center">
                    <el-button-group class="a_modal">
                        <el-button size="small" icon="el-icon-arrow-left"
                                   @click.stop="lastNextMonthClick(-1)"></el-button>
                        <el-button size="small" disabled>{{dateStr}}</el-button>
                        <el-button size="small" icon="el-icon-arrow-right"
                                   @click.stop="lastNextMonthClick(1)"></el-button>
                    </el-button-group>
                </el-col>
                <el-col :span="8">
                    <div align="right" v-show="showEdit">
                        <el-button style="background-color: #FF9901;color: white;border: #FF9901" align="right"
                                   size="small" @click.stop="editData()">
                            编辑数据
                        </el-button>
                    </div>
                </el-col>
            </el-row>
            <div style="width: 100%;margin-top: 20px">

                <el-row style="margin-bottom: 15px;margin-top: 5px">
                    <el-col :span="8" :class="$style.text">
                        <div class="grid-content bg-purple" align="center">
                            <img :src="indicators_icon" width="18px"
                                 style="margin-left: 5px;margin-right: 5px;vertical-align: middle">
                            <span>当月销售指标金额：</span>
                            <span style="color: #3998F7">{{cutTargetAmount}}</span>
                            <span :class="$style.span">元</span>
                        </div>
                    </el-col>
                    <el-col :span="8" :class="$style.text">
                        <div class="grid-content bg-purple" align="center">
                            <img :src="actual_icon" width="16px"
                                 style="margin-left: 5px;margin-right: 5px;vertical-align: middle">
                            <span>当月实际销售金额：</span>
                            <span style="color: #7ED321">{{cutActualAmount}}</span>
                            <span :class="$style.span">元</span>
                        </div>
                    </el-col>
                    <el-col :span="8" :class="$style.text">
                        <div class="grid-content bg-purple" align="center">
                            <img :src="rate_icon" width="16px"
                                 style="margin-left: 5px;margin-right: 5px;vertical-align: middle">
                            <span>当月销售达成率：</span>
                            <span style="color: #FF9901">{{cutRate === 0 ? 'N/A':cutRate}}</span>
                            <span :class="$style.span">%</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <el-table
                    :data="tableData"
                    style="width: 100%"
                    :header-cell-style="tableHeaderColor">

                <el-table-column
                        label="日期"
                        prop="sale_date"
                >
                    <template slot-scope="scope">
                        <span :style="{'color':getTabTextColor(scope.row.sale_date)}">{{scope.row.sale_date}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="销售指标金额"
                        prop="targetamount"
                        align="center"
                        width="150">
                    <template slot-scope="scope">
                        <span :style="{'color':getTabTextColor(scope.row.targetamount)}">{{scope.row.targetamount}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="实际销售金额"
                        prop="actualamount"
                        align="center"
                        width="150">
                    <template slot-scope="scope">
                        <span :style="{'color':getTabTextColor(scope.row.actualamount)}">{{scope.row.actualamount}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="销售达成率%"
                        prop="rate"
                        align="center"
                        width="150">
                    <template slot-scope="scope">
                        <span :style="{'color':getTabTextColor(scope.row.rate)}">{{scope.row.rate == '0' ? 'N/A':scope.row.rate}}</span>
                    </template>
                </el-table-column>


            </el-table>

        </div>

        <el-dialog
                :visible.sync="showModal" :show-close="false"
                width="50%" :class="$style.modal"
                :before-close="closeModal">
            <div slot="title" :class="$style.title">
                <span>指标导入</span>
                <div>
                    <el-button type="danger" size="small" @click.stop="closeModal">关闭</el-button>
                </div>
            </div>
            <el-form label-width="90px" class="a_modal">
                <el-form-item label="模板下载">
                    <el-button type="primary" size="mini">
                        <a style="text-decoration: none;color: #ffff;"
                           href="https://qidian-file.oss-cn-shanghai.aliyuncs.com/%E9%94%80%E5%94%AE%E6%8C%87%E6%A0%87%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
                           download="指标导入模板文件.xlsx" target="_blank">下载</a>
                    </el-button>
                    <i style="margin-left: 10px" class="el-icon-document"></i>
                    <span>指标导入模板文件.xlsx</span>
                </el-form-item>
                <el-form-item label="上传文件" class="d_upload">
                    <!--<el-input v-model="fileSecond"></el-input>-->
                    <el-upload
                            class="upload-demo"
                            ref="uploadSecond"
                            action="/wapi/v1/uploads"
                            :file-list="fileListSecond"
                            :on-change="handleChangeSecond"
                            :on-success="handleSuccessSecond"
                            :on-remove="handleRemove"
                            :limit="1"
                            :auto-upload="false">
                        <el-button style="color:white;" slot="trigger" size="small" type="success">选择文件</el-button>
                        <el-button style="color:white;margin-left: 10px;" size="small" type="warning"
                                   @click.stop="imortDataClickSecond">导入数据
                        </el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        </el-dialog>


        <el-dialog
                :visible.sync="showModalMonth" :show-close="false"
                width="50%" :class="$style.modal"
                :before-close="closeModal">
            <div slot="title" :class="$style.title">
                <span>编辑数据</span>
                <div>
                    <el-button type="primary" size="small" @click.stop="saveMonth">保存</el-button>
                    <el-button type="danger" size="small" @click.stop="closeModalMonth">取消</el-button>
                </div>
            </div>
            <div style="width: 100%;margin-top: -20px" align="center">
                <el-button-group style="margin-bottom: 20px">
                    <el-button size="small" icon="el-icon-arrow-left"
                               @click.stop="lastNextMonthClick(-1)"></el-button>
                    <el-button size="small" disabled>{{dateStr}}</el-button>
                    <el-button size="small" icon="el-icon-arrow-right"
                               @click.stop="lastNextMonthClick(1)"></el-button>
                </el-button-group>

                <el-form  class="a_modal" v-for="(item, index) in editTableData" :key="index" :label="item">
                    <el-form-item :label="getLabel(item)" class="m_modal">
                        <el-input :class="$style.num" v-model="item.targetamount" type="number" @input="handleChange(item,item.targetamount)"></el-input>
                        <span>元</span>
                    </el-form-item>

                </el-form>
            </div>

        </el-dialog>

    </div>
</template>

<script>

    import http from '../../../APIService/http'
    import {bus} from '../../../router/index.js'
    import l_icon from '../../../assets/images/l_icon.png'
    import r_icon from '../../../assets/images/r_icon.png'
    import indicators_icon from '../../../assets/images/indicators_icon.png'
    import actual_icon from '../../../assets/images/actual_icon.png'
    import rate_icon from '../../../assets/images/rate_icon.png'
    import echarts from 'echarts'
    import moment from 'moment'

    export default {
        data() {
            return {
                loading: false,
                showModal: false,
                showEdit: false,
                showModalMonth: false,
                chart: {},
                store_id: '',
                l_icon: l_icon,
                r_icon: r_icon,
                indicators_icon: indicators_icon,
                actual_icon: actual_icon,
                rate_icon: rate_icon,
                actualamount: 0,
                tableData: [],
                editTableData: [],
                cutTargetAmount: 0,
                cutActualAmount: 0,
                cutRate: 0,
                actualArray: [],
                targetArray: [],
                date: moment(),
                yearStr: this.getCurrentYear(),
                dateStr: this.getCurrentDate(),

                // fileSecond: '',
                isUpload: false,
                fileListSecond: [],
            }
        },
        created() {

            let obj = this.$store.getters.getStore
            this.store_id = obj.id
            if (this.store_id) {
                this.getSalesTargetByYear()//按年
                this.getSalesTargetByMonth()//按月

            }

            let user = this.$store.getters.getUser
            if(!(user.isManage && !user.isSalesDirector) || user.role === 'admin'){
                this.showEdit = true
            }else {
                this.showEdit = false
            }

            bus.$off('action_importTarget');
            bus.$on('action_importTarget', (value) => {

                this.showModal = true

            })

        },
        mounted() {

        },
        components: {},
        computed: {},
        methods: {
            increment() {
                // this.getSalesTargetByYear()
            },
            async getSalesTargetByYear() {
                try {

                    this.loading = true

                    var user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        store_id: this.store_id,
                        user_id: user.user_id,
                        year: this.yearStr
                    }
                    let t = this
                    await http.post('/wapi/v1/getSalesTargetByYear', data).then(res => {

                        t.actualArray = res.data.actualArray
                        t.targetArray = res.data.targetArray
                        t.actualamount = res.data.actualamount

                        this.initChart()

                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async getSalesTargetByMonth() {
                try {

                    this.loading = true

                    var user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        store_id: this.store_id,
                        user_id: user.user_id,
                        month: this.date.format("YYYY-MM")
                    }

                    await http.post('/wapi/v1/getSalesTargetByMonth', data).then(res => {


                        this.tableData = res.data.array
                        this.cutTargetAmount = res.data.cutTargetAmount
                        this.cutActualAmount = res.data.cutActualAmount
                        this.cutRate = res.data.cutRate

                        this.loading = false

                        if(this.showModalMonth){
                            this.editData()
                        }
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            initChart() {
                this.chart = echarts.init(this.$refs.myEchart)
                // 把配置和数据放这里
                this.chart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        }
                    },
                    // toolbox: {
                    //     feature: {
                    //         dataView: { show: false, readOnly: false },
                    //         magicType: { show: true, type: ['line', 'bar'] },
                    //         restore: { show: true },
                    //         saveAsImage: { show: true }
                    //     }
                    // },
                    legend: {
                        x: 'center',
                        data: ['实际','指标']
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                            axisPointer: {
                                type: 'shadow'
                            }
                        }],
                    yAxis: [
                        {
                            type: 'value',
                            // name: '场次',
                            interval: 50,
                            show: false,
                            axisLabel: {
                                formatter: '{value} ml'
                            }
                        },
                    ],
                    series: [
                        {
                            zlevel: 3,
                            name:'指标',
                            type: 'line',
                            data: this.targetArray,
                            itemStyle: {
                                normal: {
                                    color: '#42C4F1',
                                    // lineStyle: {
                                    //     color: '#42C4F1'
                                    // },
                                    // areaStyle: {
                                    //     color: '#E5FBF9',
                                    //     type: 'default'
                                    // }
                                }
                            },
                        },
                        {
                            name: '实际',
                            type: 'bar',
                            data: this.actualArray,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            itemStyle: {
                                normal: {
                                    barBorderRadius: [5, 5, 0, 0],
                                    color: '#FF9901',
                                }
                            },
                            barWidth: 20,
                        }],

                })
                window.onresize = this.chart.resize;


            },
            getCurrentDate() {
                let date = moment(this.date)
                return date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

            },

            getCurrentYear() {
                let date = moment(this.date)
                return date.year()
            },
            getFormatDate(arg) {

                if (!arg) {
                    return '';
                }
                var re = arg + '';
                if (re.length < 2) {
                    re = '0' + re;
                }
                return re;
            },
            lastNextYearClick(num) {

                if (num === 1) {
                    this.yearStr = parseInt(this.yearStr) + 1
                } else {
                    this.yearStr = parseInt(this.yearStr) - 1
                }
                this.getSalesTargetByYear()
            },
            lastNextMonthClick(num) {

                let currentDate = moment(this.date)
                let date = currentDate.add(num, "months")
                this.date = date
                this.dateStr = date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

                this.getSalesTargetByMonth()
            },
            // 修改table header的背景色
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return 'background-color: #E0E0E0;color: #5C575E'
                }
            },
            // 修改表里text颜色
            getTabTextColor(num) {
                // if(num === '0' || num === 0){
                return '#9B9B9B'
                // }else {
                //     return '#D0021B'
                // }

            },
            // 关闭模态框
            closeModal() {
                this.showModal = false
                this.isUpload = false
            },
            handleChangeSecond(fileSecond, fileListSecond) {

                // this.fileSecond = fileSecond.name
                const nameArr = fileSecond.name.split('.')
                const extension = nameArr[nameArr.length - 1] === 'xlsx'
                const isLt2M = fileSecond.size / 1024 / 1024 < 10
                if (!extension) {
                    // this.fileSecond = ''
                    this.fileListSecond = []
                    this.$message({
                        showClose: true,
                        message: '上传模板只能是xlsx',
                        type: 'error'
                    })
                }
                if (!isLt2M) {
                    // this.fileSecond = ''
                    this.fileListSecond = []
                    this.$message({
                        showClose: true,
                        message: '传模板大小不能超过 10MB',
                        type: 'error'
                    })
                }

                this.isUpload = true

                return extension && isLt2M
            },
            imortDataClickSecond() {
                if (this.isUpload) {
                    this.loading = true
                    this.$refs.uploadSecond.submit()
                } else {
                    this.$message({
                        showClose: true,
                        message: '导入模板不能为空',
                        type: 'error'
                    })
                }
            },
            handleRemove(file, fileList) {
                this.isUpload = false
            },
            async handleSuccessSecond(res, file) {


                if (res.success) {
                    try {
                        var user = this.$store.getters.getUser

                        let data = {
                            tenant_id: user.tenant_id,
                            store_id: this.store_id,
                            user_id: user.user_id,
                            path: res.data
                        }

                        await http.post('/wapi/v1/imortTargetData', data).then(res => {

                            if (res.success) {

                                this.showModal = false
                                // this.fileSecond = ''
                                this.fileListSecond = []

                                this.$message({
                                    type: 'success',
                                    message: '导入成功'
                                })

                                this.getSalesTargetByYear()//按年
                                this.getSalesTargetByMonth()//按月
                            } else {
                                // this.fileSecond = ''
                                this.fileListSecond = []

                                this.$message({
                                    type: 'error',
                                    message: '导入失败'
                                })
                            }

                            this.loading = false
                        })
                    } catch (err) {
                        this.loading = false
                        // this.fileSecond = ''
                        this.fileListSecond = []
                        this.error('导入失败')
                    }
                } else {
                    this.loading = false
                    // this.fileSecond = ''
                    this.fileListSecond = []
                    this.error('导入失败')
                }
            },
            getLabel(item){

                return item.sale_date
            },
            handleChange(item,num) {

                let str= num.replace('.','')

                if(str.length > 9){
                    str = str.substring(0,9)
                }

                this.$nextTick(function () {
                    if(str){
                        item.targetamount = parseInt(str)
                    }else {
                        item.targetamount = 0
                    }

                })

            },
            editData(){//编辑
                if(this.tableData.length > 0){
                    this.editTableData = []
                    for(let obj of this.tableData){
                        this.editTableData.push({
                            date:obj.date,
                            sale_date:obj.sale_date,
                            targetamount:obj.targetamount
                        })
                    }
                    this.showModalMonth = true
                }

            },
            closeModalMonth(){//取消
                this.showModalMonth = false
            },
            async saveMonth(){//保存指标
                try {
                    this.loading = true
                    var user = this.$store.getters.getUser

                    let data = {
                        tenant_id: user.tenant_id,
                        store_id: this.store_id,
                        user_id: user.user_id,
                        targetData: this.editTableData
                    }

                    await http.post('/wapi/v1/saveTargetData', data).then(res => {

                        if (res.success) {

                            this.showModalMonth = false

                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })

                            this.getSalesTargetByYear()//按年
                            this.getSalesTargetByMonth()//按月
                        } else {

                            this.$message({
                                type: 'error',
                                message: '保存失败'
                            })
                        }

                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false

                    this.error('保存失败')
                }
            },
        }
    }
</script>
<style lang="scss" module>
    .container {
        .content {

            .text {
                font-size: 13px;
                color: #4D586D;
            }
            .span {
                display: inline-block;
                font-size: 12px;
                color: #FFFFFF;
                text-align: left;
                padding: 5px;
                background: #9B9B9B;
                border-radius: 3px;
                margin-left: 5px;
                margin-right: 5px;
            }
            .span_shift {
                font-size: 12px;
                color: #FFFFFF;
                border-radius: 3px;
                padding: 4px;
                display: -moz-inline-box;
                display: inline-block;
                text-align: center;
                line-height: 15px;
                width: 50px;
            }

            .demo-table-expand {
                font-size: 0;
            }
            .demo-table-expand label {
                width: 90px;
                color: #99a9bf;
            }
            .demo-table-expand .el-form-item {
                margin-right: 0;
                margin-bottom: 0;
                width: 100%;
            }

        }
        .modal {
            .title {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: space-between;
                align-items: center;
                border-bottom: 2px dotted #e7eaec;
                padding-bottom: 10px;
                > span {
                    color: #3998f7;
                    font-size: 16px;
                }

            }
            .num{
                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button {
                    -webkit-appearance: none !important;
                    margin: 0;
                }
            }
        }
    }
</style>
<style scoped>

    .a_modal >>> .el-button {
        color: #646464;
    }


    .a_modal >>> .el-form-item__label {
        color: #000000;
        font-size: 16px;
        text-align: right;
        font-weight: bold;
        width: 35%;
    }

    .m_modal >>> .el-input {
        width: 40%;
    }

    .a_modal >>> .el-form-item__content {
        color: #000000;
        font-size: 14px;
        font-weight: bold;
    }


</style>



// WEBPACK FOOTER //
// src/pages/stores/salesTarget/index.vue